<template>
  <v-sheet class="my-cell d-flex flex-column" width="100%" height="100%" style="position: relative" :style="cell_style" v-on:click="make_selection()" v-on:mouseenter="hover_cell()" v-on:mouseleave="dehover_cell()">
    <v-sheet v-for="color in colors" :color="color" :key="color" width="100%" :height="`${100 / colors.length}%`" />
    <div class="date-helper" style="position: absolute;" v-if="period_start && period_user === human">
      <p>{{ this.day }}</p>
    </div>
  </v-sheet>
</template>

<script>
import moment from "moment";
import { Current, Deletion, Tools } from "@/store/planner/ToolsStore";
import { SP_End, SP_Start, SP_User } from "@/store/planner/SelectedPeriodStore";
import { Allerts } from "@/store/global/Allerts";
import { AllPeriods } from "@/store/planner/PeriodsStore";
import {TokenGUIDStore} from "@/store/global/SessionStore";
import {CurrentPeriod, PeriodSize} from "@/store/planner/CurrentPeriodStore";
import {IsLoading} from "@/store/directors_planner.store";

export default {
  name: "DayCell",
  props: ['periods', 'district', 'human', 'day', 'month', 'year'],
  data() {
    return {
      hover: false,
      delay: {
        object: null,
        count: 0.3 // In seconds
      },
      element: null,
      palette: {
        work: '#dedede',
        weekend: '#e87c64',
        today: '#607D8B'
      }
    }
  },
  methods: {
    hover_cell: function () {
      let ev = event
      this.delay.object = setTimeout(() => {
        this.element = document.createElement('div')

        this.element.style.position = 'absolute'
        this.element.style.top = '-35px'
        this.element.style.width = '100px'
        this.element.style.left = 'calc(50% - 50px)'
        this.element.style.textAlign = 'center'
        this.element.style.background = '#ffffff'
        this.element.style.fontSize = '16px'
        this.element.style.zIndex = '1000'
        this.element.style.padding = '2px'
        this.element.style.borderRadius = '10px'
        this.element.style.boxShadow = '4px 4px 4px 1px rgba(34, 60, 80, 0.2) inset, 4px 4px 4px 1px rgba(34, 60, 80, 0.2)'
        this.element.innerHTML = moment().set({year: this.year, month: this.month-1, date: this.day}).format('DD.MM.YYYY')

        ev.target.appendChild(this.element)
      }, this.delay.count * 1000)
    },
    dehover_cell: function () {
      if (this.element !== null) {
        event.target.removeChild(this.element)
        this.element = null
      } else {
        clearTimeout(this.delay.object)
      }
    },
    get_planner_periods: async function () {
      this.is_loading = true
      let data = JSON.stringify({
        date: this.period_current.format('YYYY-MM-DD[T]00:00:00'),
        size: this.period_size
      })
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/GetPlannerData`
      let properies = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        },
        body: data
      }
      await fetch(url, properies)
          .then(response => response.text())
          .then(async result => {
            console.log('Успешно!')
            let periods = JSON.parse(result)
            for (let district of periods) {
              district.users = district.users.sort(function (x, y) {
                if (x.user_name < y.user_name) return -1;
                if (x.user_name > y.user_name) return 1;
                return 0;
              })
            }
            this.all_periods = periods
          }).catch((err) => {
            console.log('Ошибка получения данных...')
            console.warn(err)
          }).finally(() => {
            this.is_loading = false
          })
    },
    save_period: async function () {
      this.is_loading = true
      console.log('Сохраняю период!')
      let prepared_data = {
        person_guid: this.human,
        date_start: this.period_start.format('YYYY-MM-DDT00:00:00'),
        date_end: this.period_end.format('YYYY-MM-DDT00:00:00'),
        group: this.current_tool.group_guid,
        direction: this.current_tool.direction_guid,
        is_deletion: this.deletion
      }
      console.log(prepared_data)

      let data = JSON.stringify(prepared_data)
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/SetPlannerPeriod`
      let properies = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        },
        body: data
      }
      await fetch(url, properies)
          .then(response => response.text())
          .then(async result => {
            console.log(result)
            await this.clear_period()
          }).catch((err) => {
            console.log('Ошибка получения данных...')
            console.warn(err)
          }).finally(() => {
            this.is_loading = false
          })

    },
    clear_period: async function () {
      console.log('Чищу нычки')

      this.period_start = null
      this.period_end = null
      this.period_user = null

      await this.get_planner_periods()
    },
    make_selection: async function () {
      let group = this.current_tool.group_guid
      let direction = this.current_tool.direction_guid
      let color = null
      if (group) {
        let tool = this.tools.find(el => el.guid === group)
        color = tool.color
        if (direction) {
          let sub = tool.directions.find(el => el.guid === direction)
          color = sub.color
        }
      }

      if (group || this.deletion) {
        if (this.period_start === null) {
          let tmp_color = document.createElement('div')
          tmp_color.style.position = 'absolute'
          tmp_color.style.top = 0
          tmp_color.style.left = 0
          tmp_color.style.width = '100%'
          tmp_color.style.height = '100%'
          tmp_color.style.backgroundColor = this.deletion ? 'red' : color
          event.target.appendChild(tmp_color)

          this.period_user = this.human
          this.period_start = moment(`${this.year}-${this.month}-${this.day < 10 ? '0' + this.day : this.day}T00:00:00`)
          Allerts().warn('ПОДСКАЗКА', 'Вы выбрали начало периода! Укажите у выбранного сотрудника окончание периода', '#C5E1A5', 'message')
        } else {
          this.period_end = moment(`${this.year}-${this.month}-${this.day < 10 ? '0' + this.day : this.day}T00:00:00`)

          if (this.period_end < this.period_start) {
            let tmp = this.period_end
            this.period_end = this.period_start
            this.period_start = tmp
          }
          await this.save_period()
        }
      } else {
        Allerts().allert('ОШИБКА', 'Выберите инструмент!', 'triangle-exclamation')
      }
    }
  },
  computed: {
    session_token() {
      return TokenGUIDStore().get()
    },
    period_current: {
      get() {
        return CurrentPeriod().get()
      },
      set(value) {
        CurrentPeriod().set(value)
      }
    },
    is_loading: {
      get() {
        return IsLoading().get()
      },
      set(value) {
        IsLoading().set(value)
      }
    },
    period_size: {
      get() {
        return PeriodSize().get()
      },
      set(value) {
        PeriodSize().set(value)
      }
    },
    all_periods: {
      get() {
        return AllPeriods().get()
      },
      set(value) {
        AllPeriods().set(value)
      }
    },
    weekday() {
      return moment(`${this.year}-${this.month}-${this.day}`).weekday()
    },
    cell_style() {
      let cell_date = moment(`${this.year}-${this.month}-${this.day}`)
      let weekday = cell_date.weekday()
      let style = ''
      if (cell_date.format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {
        style += `border: 1px dotted ${this.palette.today}`
      } else if (weekday === 5 || weekday === 6) {
        style += `border: 1px dotted ${this.palette.weekend}`
      } else {
        style += `border: 1px dotted ${this.palette.work}`
      }
      return style
    },
    colors() {
      let district = this.periods.find(el => el.district_guid === this.district)
      let human = district.users.find(el => el.user_guid === this.human)
      let cell_date = moment(`${this.year}-${this.month}-${this.day}`)
      let colors = []
      if (human.periods) {
        for (let period of human.periods) {
          if (moment(cell_date).isBetween(period.date_start, period.date_end, undefined, '[]')) {
            let group = period.period_guid
            let direction = period.direction_guid
            group = this.tools.find(el=>el.guid === group)
            if (group.directions) {
              direction = group.directions.find(el=>el.guid === direction)
              colors.push(direction.color)
            } else {
              colors.push(group.color)
            }
          }
        }
      }

      colors = colors.sort()

      return colors
    },
    tools: {
      get() {
        return Tools().get()
      },
      set(value) {
        Tools().set(value)
      }
    },
    deletion: {
      get() {
        return Deletion().get()
      },
      set(value) {
        Deletion().set(value)
      }
    },
    current_tool: {
      get() {
        return Current().get()
      },
      set(value) {
        Current().set(value)
      }
    },
    period_start: {
      get() {
        return SP_Start().get()
      },
      set(value) {
        SP_Start().set(value)
      }
    },
    period_end: {
      get() {
        return SP_End().get()
      },
      set(value) {
        SP_End().set(value)
      }
    },
    period_user: {
      get() {
        return SP_User().get()
      },
      set(value) {
        SP_User().set(value)
      }
    }
  }
}

</script>

<style scoped>
.my-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  padding: 1px;
  font-family: "Arial Black", Serif;
  font-size: 8px;
  aspect-ratio: 1 / 1;
}
.date-helper {
  display: flex;
  width: 70%;
  height: 70%;
  align-items: center;
  justify-content: center;
  background-color: white;
  font-family: "Arial Black", Serif;
  color: black;
  font-size: 8px;
  aspect-ratio: 1 / 1;
  border-radius: 100px;
}
</style>
